


import SlDetails from '@shoelace-style/shoelace/dist/react/details';
import SlIcon from '@shoelace-style/shoelace/dist/react/icon';

const css = `
  .site-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    padding: 22px 28px 20px;
    border-top: 1px solid lightgray;
    font-size: small;
  }
  
  .footer-links {
    display: flex;
    flex-direction: column;
    gap: 7px;
    align-items: flex-start;
    line-height: 1.5;
  }
  
  .footer-links a {
    text-decoration: none;
    transition: opacity 0.2s ease;
  }
  
  .footer-links a:hover {
    opacity: 0.75;
    text-decoration: underline;
  }
  
  .footer-meta {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 18px;
    line-height: 1.5;
    white-space: nowrap;
  }
  
  .social-links {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  
  .social-badge {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
  }
  
  @media (max-width: 700px) {
    .site-footer {
      flex-direction: column;
      align-items: flex-start;
    }
  
    .footer-meta {
      width: 100%;
      justify-content: space-between;
      white-space: normal;
    }
  }
`;

const Footer = () => {
  return (
  <div>
   <footer className="site-footer">
          <div className="footer-links">
            <a href="/terms">Terms of Service</a>
            <a href="/privacy">Privacy policy</a>
          </div>

          <div className="footer-meta">
            <span>HomeKeepy. All rights reserved</span>
            <div className="social-links" aria-label="Social media">
             {/*  <span className="social-badge">◎</span>
              <span className="social-badge">X</span>
              <span className="social-badge">f</span> */}
            </div>
          </div>
        </footer>

    <style>{css}</style>
  </div>
)};

export default Footer;

      